<template>
  <div style="position: relative;">
    <!--<div class='number-indicator'>
      <span class='number'>2</span>
    </div>-->
    <div class="fl hf">
      <div class="form-input-container hf mb-4">
        <div class="form-input-container-header">
          <div style="display: flex; align-Items: center;" :class="this.text ? '' : 'mb-3'">
            <h6>{{this.title}}</h6>
            <slot name="title" />
          </div>
          <div v-if="this.text" style="display: flex; align-Items: center;" class="mb-4">
            <p>{{this.text}}</p>
            <slot name="text" />
          </div>
        </div>

        <div class="hf form-input-container-content">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormInputContainer",
  props: {
    title: String,
    text: String
  }
};
</script>

<style lang="scss" scoped>
@import "../../utils/assets/stylesheets/variables.scss";

.number-indicator {
  position: absolute;
  left: -43px;
  top: 14px;
  border-radius: 5px;
  background-color: #f3f4f8;
  display: block;
  width: 24px;
  height: 30px;

  .number {
    margin: 0 auto;
    display: block;
    text-align: center;
    position: relative;
    top: 3px;
    font-weight: 700;
    font-size: 1em;
    color: #606a86;
  }
}

.form-input-container {
  position: relative;
  padding: 10px 0px;
  border-radius: $border-radius;

  h6 {
    color: $primary;
    font-weight: 600;
    position: relative;
    font-size: 1em;
    white-space: nowrap;
    background-color: gray-lighten-2;
  }

  p {
    color: $primary-lighten-1;
    font-size: 1em;
  }
}

.form-input-container-header {
  position: relative;
}

.form-input-container-content {
  position: relative;
}
</style>
